<template>
  <div class="Auth" :class="[routeName, authClasses]">
    <Transition name="fade" mode="out-in">
      <RouterView :key="$route.name" />
    </Transition>
  </div>
</template>

<script>
export default {
  name: 'AuthLayout',

  metaInfo: {
    bodyAttrs: {
      class: 'auth',
    },
  },

  computed: {
    routeName() {
      return this.$route.name
    },
    isWhitelabel() {
      return this.$store.getters['whitelabel/is_whitelabel']
    },
    authBgColor() {
      return this.$store.getters['whitelabel/auth_bg_color']
    },
    authBgImage() {
      return this.$store.getters['whitelabel/auth_bg_image']
    },
    authClasses() {
      return {
        'Auth--whitelabel-bg': this.isWhitelabel && this.authBgImage,
        'Auth--whitelabel-no-bg': this.isWhitelabel && !this.authBgImage,
      }
    },
  },

  mounted() {
    if (!this.isWhitelabel) return

    const body = document.body

    if (this.authBgColor) {
      body.style.setProperty('--wl-auth-bg-color', this.authBgColor)
    }
    if (this.authBgImage) {
      body.style.setProperty('--wl-auth-bg-image', `url(${this.authBgImage})`)

      const bgSize = this.$store.getters['whitelabel/auth_bg_size']
      const bgRepeat = this.$store.getters['whitelabel/auth_bg_repeat']
      const bgPosition = this.$store.getters['whitelabel/auth_bg_position']
      if (bgSize) body.style.setProperty('--wl-auth-bg-size', bgSize)
      if (bgRepeat) body.style.setProperty('--wl-auth-bg-repeat', bgRepeat)
      if (bgPosition) body.style.setProperty('--wl-auth-bg-position', bgPosition)
    }
  },

  beforeDestroy() {
    const body = document.body
    body.style.removeProperty('--wl-auth-bg-color')
    body.style.removeProperty('--wl-auth-bg-image')
    body.style.removeProperty('--wl-auth-bg-size')
    body.style.removeProperty('--wl-auth-bg-repeat')
    body.style.removeProperty('--wl-auth-bg-position')
  },
}
</script>

<style lang="scss">
@import '@/assets/fonts/bitter.scss';
@import '@/assets/sass/layouts/_auth.scss';
</style>
